export const calcTotal = <T>(arr: T[], condition: (item: T) => number) =>
  arr.reduce((acc, item) => acc + condition(item), 0);
